import React, { useEffect, useRef, useState } from "react";
import blogFetch from "../../axios/config";
import { getIdCompany } from "../../utils/constantes";
import moment from "moment";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  IOccurrence,
  ISector,
  ISkuEquipment,
  ITypeOccurrence,
} from "./occurrenceInterfaces";
import "moment/locale/pt-br";
import { TextField } from "@mui/material";

const { forwardRef, useImperativeHandle } = React;

export default forwardRef((props: any, ref) => {
  const [ocurrence, setOcurrence] = useState<IOccurrence>({
    ocC_PK_idOccurrence: 0,
    ocC_DATE: "",
    ocC_downtime: 0,
    ocC_justify: "",
    ocC_FK_typeOccurrenceId: 0,
    ocC_FK_skuEquipId: 0,
    ocC_FK_collaboratorId: 0,
    ocC_FK_sectorId: 0,
    ocC_FK_companyId: 0,
  });
  const [selectedValueSkuEquip, setSelectedValueSkuEquip] = useState<ISkuEquipment[]>([]);
  const [selectedValueSector, setSelectedValueSector] = useState<ISector[]>();
  const [selectedTypeOcurrence, setSelectedTypeOcurrence] = useState<ITypeOccurrence[]>();
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [tipeTime, setTipeTime] = useState<number>(1);
  const [valueTime, setValueTime] = useState<number>(0);

  useEffect(() => {
    getOcurrence();
    getTypeOcurrence();
    getSkuEquip();
    getSector();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useImperativeHandle(ref, () => ({
    addOcurrence,
    updateOcurrence,
  }));

  const handleChangeSku = (event: SelectChangeEvent<string>) => {
    const selectedManufacturer = selectedValueSkuEquip?.find(
      (item) => item.skE_PK_idSkuEquip === Number.parseInt(event.target.value)
    );
    if (selectedManufacturer) {
      setOcurrence({
        ...ocurrence,
        ocC_FK_skuEquipId: selectedManufacturer?.skE_FK_sectorId
      });
    }
  };

  const handleChangeSector = (event: SelectChangeEvent<string>) => {
    const selectedSector = selectedValueSector?.find(
      (item) => item.stR_PK_idSector === Number.parseInt(event.target.value)
    );
    if (selectedSector) {
      setOcurrence({
        ...ocurrence,
        ocC_FK_sectorId: selectedSector?.stR_PK_idSector
      });
    }
  };
  const handleChangeTipeTime = (event: SelectChangeEvent<string>) => {
    setTipeTime(Number.parseInt(event.target.value));
  };

  const handleChangeTypeOcurrence = (event: SelectChangeEvent<string>) => {
    const typeOcurrence = selectedTypeOcurrence?.find(
      (item) =>
        item.tpO_PK_idTypeOccurrence === Number.parseInt(event.target.value)
    );
    if (typeOcurrence) {
      setOcurrence({
        ...ocurrence,
        ocC_FK_typeOccurrenceId: typeOcurrence?.tpO_PK_idTypeOccurrence,
      });
    }
  };

  const addOcurrence = async () => {
    const timeInMinutes: number = getTimeInMinutes(valueTime);
    const newOcurrence: IOccurrence = {
      ...ocurrence,
      ocC_DATE: moment(currentDateTime)
        .locale("pt-br")
        .format("YYYY-MM-DDTHH:mm:ss"),
      ocC_downtime: timeInMinutes,
      ocC_FK_companyId: getIdCompany(),
    };

    try {
      const response = await blogFetch.post("/Occurrence", newOcurrence);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getTimeInMinutes = (time: number) => {
    let minuteDay = 1440;
    if (tipeTime === 1) {
      return time;
    } else if (tipeTime === 2) {
      return time * 60;
    } else if (tipeTime === 3) {
      return time * minuteDay;
    }
    return 0;
  };
  
  const updateOcurrence = async () => {
    const timeInMinutes: number = getTimeInMinutes(valueTime);

    const newOcurrence: IOccurrence = {
      ...ocurrence,
      ocC_DATE: moment(currentDateTime)
        .locale("pt-br")
        .format("YYYY-MM-DDTHH:mm:ss"),
      ocC_downtime: timeInMinutes,
      ocC_FK_companyId: getIdCompany(),
    };

    try {
      const response = await blogFetch.put(
        `/Occurrence/${props.IdOcurrence}`,
        newOcurrence
      );
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getSector = async () => {
    try {
      let response = await blogFetch.get("/sector");
      let data = response.data;
      setSelectedValueSector(data);
    } catch (error) {
      console.error(error);
    }
  };
  const getOcurrence = async () => {
    if(props.IdOcurrence){

      try {
        let response = await blogFetch.get("/Occurrence/" + props.IdOcurrence);
        let data = response.data;
        setOcurrence(data);
      } catch (error) {
        console.error(error);
      }
    }
  };
  const getTypeOcurrence = async () => {
    try {
      let response = await blogFetch.get("/typeOccurrence");
      let data = response.data;
      setSelectedTypeOcurrence(data);
    } catch (error) {
      console.error(error);
    }
  };
  const getSkuEquip = async () => {
    try {
      let response = await blogFetch.get("/skuEquipment");
      let data = response.data;
      setSelectedValueSkuEquip(data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <TextField
          required
          id="outlined-basic"
          label="Justificativa"
          variant="outlined"
          fullWidth
          className="mb-3"
          value={ocurrence.ocC_justify}
          onChange={(e) =>
            setOcurrence({ ...ocurrence, ocC_justify: e.target.value })
          }
        />{" "}
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">
            Tipo de ocorrência
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={ocurrence.typeOccurrence?.tpO_description}
            label="Tipo de ocorrência"
            onChange={handleChangeTypeOcurrence}
          >
            {selectedTypeOcurrence &&
              selectedTypeOcurrence.map((item) => (
                <MenuItem
                  key={item.tpO_PK_idTypeOccurrence}
                  value={item.tpO_PK_idTypeOccurrence}
                >
                  {item.tpO_description}
                </MenuItem>
              ))}
            {ocurrence.typeOccurrence?.tpO_description && (
              <MenuItem
                key={ocurrence.typeOccurrence?.tpO_PK_idTypeOccurrence}
                value={ocurrence.typeOccurrence?.tpO_PK_idTypeOccurrence}
              >
                {`${ocurrence.typeOccurrence?.tpO_description} `}
              </MenuItem>
            )}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Equipamento</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={ocurrence.skuEquipment?.skE_description}
            label="Equipamento"
            onChange={handleChangeSku}
          >
            {selectedValueSkuEquip &&
              selectedValueSkuEquip.map((item) => (
                <MenuItem
                  key={item.skE_PK_idSkuEquip}
                  value={item.skE_PK_idSkuEquip}
                >
                  {item.skE_description}
                </MenuItem>
              ))}
            {ocurrence.skuEquipment?.skE_description && (
              <MenuItem
                key={ocurrence.skuEquipment?.skE_PK_idSkuEquip}
                value={ocurrence.skuEquipment?.skE_PK_idSkuEquip}
              >
                {`${ocurrence.skuEquipment?.skE_description} `}
              </MenuItem>
            )}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Setor</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={ocurrence.sector?.stR_description}
            label="Setor"
            onChange={handleChangeSector}
          >
            {selectedValueSector &&
              selectedValueSector.map((item) => (
                <MenuItem
                  key={item.stR_PK_idSector}
                  value={item.stR_PK_idSector}
                >
                  {item.stR_description}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <div style={{ display: "flex", gap: 10 }}>
          <FormControl style={{ minWidth: "125px" }}>
            <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={tipeTime.toString()}
              label="Tipo"
              onChange={handleChangeTipeTime}
            >
              <MenuItem value={1}>Minutos</MenuItem>
              <MenuItem value={2}>Horas</MenuItem>
              <MenuItem value={3}>Dias</MenuItem>
            </Select>
          </FormControl>
          <TextField
            required
            id="outlined-basic"
            label="Tempo"
            variant="outlined"
            value={valueTime}
            type="number"
            onChange={(event) =>
              setValueTime(Number.parseInt(event.target.value))
            }
            fullWidth
            className="mb-3"
          />
        </div>
      </div>
    </>
  );
});
